import { render, staticRenderFns } from "./MevConfig.vue?vue&type=template&id=13607056&scoped=true"
import script from "./MevConfig.vue?vue&type=script&lang=js"
export * from "./MevConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13607056",
  null
  
)

export default component.exports